/**
 * `category-series` v1 — counts per tenant, bucket and category.
 *
 * A row is a positive count; a category with no row in a bucket has a count of
 * zero. Categories are not a fixed list: they differ between tenants and appear
 * or disappear from one bucket to the next, so consumers derive them from the
 * rows. Buckets are ISO calendar periods (`YYYY-MM` for months).
 */
export const CATEGORY_SERIES_CONTRACT = {
  name: "category-series",
  version: 1,
} as const;

export interface CategoryPoint {
  tenantId: number;
  /** Calendar period, `YYYY-MM` for a month. */
  bucket: string;
  category: string;
  count: number;
}

export interface CategoryFreshness {
  generatedAt: string;
  dataThrough: string;
  /** "demo", "clickhouse", or a named upstream feed. */
  source: string;
  isEstimated: boolean;
}

export interface CategorySeriesData {
  points: CategoryPoint[];
  freshness: CategoryFreshness | null;
  /** The requested period (ISO instants, `to` excluded); every month in it is a bucket. */
  period?: { from: string; to: string } | null;
}
